<template>
    
</template>

<script>
import * as d3 from 'd3';

export default {
  props: {
    chartData: {
      type: Object,
      default: {}
    }
  },
  data() {
    return {
      margin: {
        top: 38,
        right: 40,
        bottom: 20,
        left: 220,
        scale_treshold: 20,
        total_column: 150
      },

      selector: '#gantt-chart-canvas',
      timeDomainStart: d3.timeMonth.offset(new Date(), -6),
      timeDomainEnd: d3.timeMonth.offset(new Date(), +6),
      projectNames: [],
      projectStatus: [],
      height: null,
      width: null,
      innerTextMargin: 12,
      today: null,
      // tickFormat: "%H:%M",
      predictions: [],
      newYearArr: [],
      xScale: null,

      // x scale copy for zoom rescaling
      xScale2: null,

      yScale: null,
      yAxis: null,

    };
  },
  mounted() {
    this.initAxis();
    this.draw();
  },
  methods: {
    redrawActual() {
      const _ = this;
      d3.selectAll('.actual-group').each(function (d, i) {
        d3.select(this).selectAll('rect')
          .attr('x', (d) => {
            return _.xScale2(new Date(d.first_date));
          })
          .attr('width', (d) => {
            return Math.max(1, (_.xScale2(new Date(d.last_date)) - _.xScale2(new Date(d.first_date))));
          });
      });
    },

    redrawPredictions() {
      const _ = this;
      d3.selectAll('.prediction-group').each(function (d, i) {
        d3.select(this).selectAll('rect')
          .attr('x', (d) => {
            return _.xScale2(new Date(d.start_date));
          })
          .attr('width', (d) => {
            return Math.max(1, (_.xScale2(new Date(d.end_date)) - _.xScale2(new Date(d.start_date))));
          });
      });
    },

    redrawTodayLine() {
      d3.select('#today-line')
        .attr('x1', this.xScale2(this.chartData.today))
        .attr('x2', this.xScale2(this.chartData.today));
    },

    drawYearLines() {
      const _ = this;
      d3.selectAll('.new-year-arr-group').each(function (d, i) {
        d3.select(this).selectAll('line')
          .attr('x1', (d) => {
            return _.xScale2(d);
          })
          .attr('x2', (d) => {
            return _.xScale2(d);
          });
      });
    },

    redrawContractTotal() {
      const _ = this;
      d3.selectAll('.contract-total-group').each(function (d, i) {
        d3.select(this).selectAll('text')
          .attr('x', (d) => {
            return _.xScale2(new Date(d.first_date)) + _.innerTextMargin;
          })
          .attr('y', (d) => {
            return _.yScale(d.name) + 25;
          });
      });
    },

    redrawActualValues() {
      const _ = this;
      d3.selectAll('.actual-values-group').each(function (d, i) {
        d3.select(this).selectAll('text')
          .attr('x', (d) => {
            return _.xScale2(new Date(d.first_date)) + Math.max(1, (_.xScale2(new Date(d.last_date)) - _.xScale2(new Date(d.first_date)))) - _.innerTextMargin * `${Number(d.actuals)}`.length;
          })
          .attr('y', (d) => {
            return _.yScale(d.name) + 25;
          });
      });
    },

    redrawEacValues() {
      const _ = this;
      d3.selectAll('.eac-values-group').each(function (d, i) {
        d3.select(this).selectAll('text')
          .attr('x', (d) => {
            return _.xScale2(new Date(d.first_date)) + Math.max(1, (_.xScale2(new Date(d.last_date)) - _.xScale2(new Date(d.first_date)))) - _.innerTextMargin * `${Number(d.eac)}`.length;
          })
          .attr('y', (d) => {
            return _.yScale(d.name) + 25;
          });
      });
    },

    initAxis() {
      const copyToday = new Date(this.chartData.today.valueOf());
      copyToday.setMonth(copyToday.getMonth() + 2);
      this.width = document.getElementById('gantt-chart-canvas').clientWidth - this.margin.right - this.margin.left - 5;

      this.xScale = d3.scaleTime()
        .domain([this.timeDomainStart, this.timeDomainEnd])
        .range([0, this.width]);

      // x scale copy for zoom rescaling
      this.xScale2 = this.xScale.copy();

      this.yScale = d3.scaleBand().domain(this.chartData.projectNames).rangeRound([0, this.chartData.height - this.margin.top - this.margin.bottom]).padding(0.1);
      this.yAxis = d3.axisLeft().scale(this.yScale).tickSize(0);
    },

    customizedXTicks(selection, scale) {
      selection.call(d3.axisBottom(scale));
    },

    customizedXTicksWeeks(selection, scale) {
      selection.call(d3.axisBottom(scale).ticks(d3.timeWeek).tickFormat(d3.timeFormat('%V')));
    },
    keyFunction(d) {
      return new Date(d.first_date) + d.name + new Date(d.last_date) + d.type;
    },
    predictionKeyFunction(d) {
      return new Date(d.start_date) + d.name + new Date(d.end_date) + d.type;
    },
    draw() {
      // zoom function 
      const zoom = d3.zoom()
        .on('zoom', () => {
          // update this.xScale's new domain after zoom
          this.xScale2.domain(d3.event.transform.rescaleX(this.xScale).domain());
          this.drawYearLines();
          this.redrawActual();
          this.redrawPredictions();
          this.redrawTodayLine();
          this.redrawContractTotal();
          this.redrawActualValues();
          this.redrawEacValues();

          svg.select('.x-axis')
            .call(this.customizedXTicks, d3.event.transform.rescaleX(this.xScale))
            .selectAll('.x-axis .tick > text') // center label
            .style('text-anchor', 'start')
          // .attr("x", 47);
            .attr('dx', '4.5em');

          svg.select('.x-axis-bottom')
            .call(this.customizedXTicks, d3.event.transform.rescaleX(this.xScale))
            .selectAll('.x-axis-bottom .tick > text') // center label
            .style('text-anchor', 'start')
          // .attr("x", 47);
            .attr('dx', '4.5em');
          // svg.select(".x-axis2")
          //     .call(d3.axisBottom(d3.event.transform.rescaleX(this.xScale)));
          svg.select('.x-axis2')
            .call(this.customizedXTicksWeeks, d3.event.transform.rescaleX(this.xScale));

          svg.select('.x-axis2-bottom')
            .call(this.customizedXTicksWeeks, d3.event.transform.rescaleX(this.xScale));
        })
        .scaleExtent([-Infinity, Infinity]);

      // initAxis();

      var svg = d3.select(this.selector)
        .append('svg')
        .attr('class', 'chart')
        .attr('width', this.width + this.margin.left + this.margin.right)
        .attr('height', this.chartData.height + this.margin.top + this.margin.bottom)
        .call(zoom)
        .append('g')
        .attr('class', 'gantt-chart')
        .attr('width', this.width + this.margin.left + this.margin.right)
        .attr('height', this.chartData.height + this.margin.top + this.margin.bottom)
        .attr('transform', `translate(${this.margin.left}, ${this.margin.top})`); // centers element

      // clippath 
      svg.append('defs').append('clipPath')
        .attr('id', 'clip')
        .append('rect')
        .attr('x', this.margin.total_column)
        .attr('width', this.width)
        .attr('height', this.chartData.height);

      // DRAW PROFIT COLUMN
      const profitGroup = svg.append('g').attr('class', 'profit-group');
      profitGroup.selectAll('.profit-text')
        .data(this.chartData.projects.filter((project) => project.type !== 'FUTURE')).enter()
        .append('text')
        .style('font-size', '14px')
        .attr('dy', '.35em')
        .attr('x', (d) => {
          return (this.margin.total_column / 2) - ((d.contract_total - d.eac).toString().length * 3);
        })
        .attr('y', (d) => {
          return this.yScale(d.name) + 15;
        })
        .attr('fill', (d) => {
          return (d.contract_total - d.eac <= 0) ? 'red' : 'black';
        })
        .text((d) => {
          return d.contract_total - d.eac;
        });

      // DRAW COLUMN LABELS
      svg.append('text')
        .style('font-size', '18px')
        .attr('dy', '.35em')
        .attr('x', -130) // @TODO create a constant 
        .attr('y', -20)
        .attr('fill', 'black')
        .text('Project name');

      svg.append('text')
        .style('font-size', '18px')
        .attr('dy', '.35em')
        .attr('x', 60)
        .attr('y', -20)
        .attr('fill', 'black')
        .text('Profit');

      // DRAW ACTUAL
      var actualGroup = svg.append('g').attr('class', 'actual-group');
      actualGroup.selectAll('rect')
        .data(this.chartData.projects, this.keyFunction)
        .enter().append('rect')
        .attr('rx', 5) // apaļi stūri priekš rect
        .attr('ry', 5)
        .attr('clip-path', 'url(#clip)')

        .attr('class', (d) => {
          if (this.chartData.projectStatus[d.type] == null) {
            return 'bar';
          }
          return this.chartData.projectStatus[d.type]; // css class mapping
        })
        .attr('x', (d) => {
          return this.xScale2(new Date(d.first_date));
        })
        .attr('y', (d) => {
          return this.yScale(d.name);
        })
        .attr('height', (d) => {
          return this.yScale.bandwidth();
        })
        .attr('width', (d) => {
          return Math.max(1, (this.xScale2(new Date(d.last_date)) - this.xScale2(new Date(d.first_date))));
        });

      // DRAW PREDICTIONS
      const predictionGroup = svg.append('g').attr('class', 'prediction-group');
      predictionGroup.selectAll('rect')
        .data(this.chartData.predictions, this.predictionKeyFunction)
        .enter().append('rect')
        .attr('rx', 5) // round circles
        .attr('ry', 5)
        .attr('clip-path', 'url(#clip)')
        .attr('class', (d) => {
          if (this.chartData.projectStatus[d.type] == null) {
            return 'bar';
          }
          return this.chartData.projectStatus[d.type]; // css class mapping
        })
        .attr('x', (d) => {
          return this.xScale2(new Date(d.start_date));
        })
        .attr('y', (d) => {
          return this.yScale(d.name);
        })
        .attr('height', (d) => {
          return this.yScale.bandwidth();
        })
        .attr('width', (d) => {
          return Math.max(1, (this.xScale2(new Date(d.end_date)) - this.xScale2(new Date(d.start_date))));
        });

      // DRAW CONTRACT TOTAL TEXT
      const contractTotalGroup = svg.append('g').attr('class', 'contract-total-group');
      contractTotalGroup.selectAll('.contract-total-text')
        .data(this.chartData.projects.filter((project) => project.type !== 'FUTURE')).enter()
        .append('text')
        .style('fill', 'black')
        .style('font-size', '14px')
        .attr('clip-path', 'url(#clip)')
        .attr('dy', '.35em')
        .attr('x', (d) => {
          return this.xScale2(new Date(d.first_date)) + this.innerTextMargin;
        })
        .attr('y', (d) => {
          return this.yScale(d.name) + 25;
        })
        .style('style', 'label')
        .text((d) => {
          return d.contract_total;
        });

      // DRAW ACTUAL TEXT
      var actualGroup = svg.append('g').attr('class', 'actual-values-group');
      actualGroup.selectAll('.actual-values-text')
        .data(this.chartData.projects.filter((project) => project.has_future_part)).enter()
        .append('text')
        .style('fill', 'black')
        .style('font-size', '14px')
        .attr('clip-path', 'url(#clip)')
        .attr('dy', '.35em')
        .attr('x', (d) => {
          return this.xScale2(new Date(d.first_date)) + Math.max(1, (this.xScale2(new Date(d.last_date)) - this.xScale2(new Date(d.first_date)))) - this.innerTextMargin * `${Number(d.actuals)}`.length;
        })
        .attr('y', (d) => {
          return this.yScale(d.name) + 25;
        })
        .style('style', 'label')
        .text((d) => {
          return Number(d.actuals);
        });

      // DRAW EAC TEXT
      const eacGroup = svg.append('g').attr('class', 'eac-values-group');
      eacGroup.selectAll('.eac-values-text')
        .data(this.chartData.projects.filter((project) => !project.has_future_part)).enter()
        .append('text')
        .style('fill', 'black')
        .style('font-size', '14px')
        .attr('clip-path', 'url(#clip)')
        .attr('dy', '.35em')
        .attr('x', (d) => {
          return this.xScale2(new Date(d.first_date)) + Math.max(1, (this.xScale2(new Date(d.last_date)) - this.xScale2(new Date(d.first_date)))) - this.innerTextMargin * `${Number(d.eac)}`.length;
        })
        .attr('y', (d) => {
          return this.yScale(d.name) + 25;
        })
        .style('style', 'label')
        .text((d) => {
          return Number(d.eac);
        });

      // render today line
      svg.append('line')
        .style('stroke', 'red')
        .style('stroke-width', 3)
        .attr('id', 'today-line')
        .attr('x1', this.xScale2(this.chartData.today))
        .attr('y1', 0)
        .attr('x2', this.xScale2(this.chartData.today))
        .attr('y2', this.chartData.height)
        .attr('clip-path', 'url(#clip)');

      // console.log("this.xScale2" ,this.xScale2)
      const newYearArrGroup = svg.append('g').attr('class', 'new-year-arr-group');
      newYearArrGroup.selectAll('line')
        .data(this.chartData.newYearArr)
        .enter()
        .append('line')
        .style('stroke-width', 1)
        .attr('class', 'year-line')
        .attr('x1', (d) => {
          return this.xScale2(d);
        })
        .attr('y1', 0)
        .attr('x2', (d) => {
          return this.xScale2(d);
        })
        .attr('y2', this.chartData.height)
        .attr('clip-path', 'url(#clip)');

      // render y-axis
      svg.append('g').attr('class', 'y-axis').transition().call(this.yAxis);

      // render x-axis top
      svg.append('g')
        .attr('class', 'x-axis')
        .attr('clip-path', 'url(#clip)')
        .attr('transform', `translate(0, ${-this.margin.top})`)
      // .attr("transform", "translate(0, " + (height - margin.top - margin.bottom) + ")")
        .call(this.customizedXTicks, this.xScale)
        .selectAll('.x-axis .tick > text') // center label
        .style('text-anchor', 'start')
        .attr('dx', '4.5em');
      // .attr("x", 47);

      this.xScaleWeeks = this.xScale.copy();

      // render week date axis top
      svg.append('g')
        .attr('class', 'x-axis2')
        .attr('clip-path', 'url(#clip)')
        .attr('transform', `translate(0, ${-this.margin.top + this.margin.scale_treshold})`)
      // .attr("transform", "translate(0, " + (height - margin.top) + ")")
        .call(this.customizedXTicksWeeks, this.xScaleWeeks);

      // render x-axis bottom
      svg.append('g')
        .attr('class', 'x-axis-bottom')
        .attr('clip-path', 'url(#clip)')
        .attr('transform', `translate(0, ${this.chartData.height - this.margin.top - this.margin.bottom})`)
        .call(this.customizedXTicks, this.xScale)
        .selectAll('.x-axis-bottom .tick > text') // center label
        .style('text-anchor', 'start')
      // .attr("x", 47);
        .attr('dx', '4.5em');

      // render week date axis bottom
      svg.append('g')
        .attr('class', 'x-axis2-bottom')
        .attr('clip-path', 'url(#clip)')
        .attr('transform', `translate(0, ${this.chartData.height - this.margin.top})`)
        .call(this.customizedXTicksWeeks, this.xScaleWeeks);
    }
  }
};

// };
</script>
